import { render, staticRenderFns } from "./ApplicationItem.vue?vue&type=template&id=5137a148&scoped=true&"
import script from "./ApplicationItem.vue?vue&type=script&lang=js&"
export * from "./ApplicationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137a148",
  null
  
)

export default component.exports